export interface ForemanCustomerContact {
  foremanCustomerContactID: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  createdDate?: Date | string | null;
  modifiedDate?: Date | string | null;
}
